import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})

export class ProfileService {

  configService: ConfigService;

  constructor(private http: HttpClient) {
    this.configService = new ConfigService();
  }

  changeProfilePhoto(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/loadAvatar'), data, { headers });
  }

  getUserStatistics() {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/dashboardLocker'), { headers });
  }

  getAdminDashboard() {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.get(this.configService.serverIp.concat('/dashboardAdmin'), { headers });
  }

  //
  setFavoriteLocation(location_id) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    const data = {
      'location_id': location_id
    };
    return this.http.post(this.configService.serverIp.concat('/setFavoriteLocation'), data, { headers });
  }

  deleteLocation(location_id) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    const data = {
      'location_id': location_id
    };
    return this.http.post(this.configService.serverIp.concat('/deleteLocationOfUser'), data, { headers });
  }

  deleteLocationToUser(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/deleteLocationToUser'), data, { headers });
  }

  deleteSimpleGuide(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/deleteSimpleGuide'), data, { headers });
  }

  cancelGuideToUser(data) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    return this.http.post(this.configService.serverIp.concat('/cancelGuideToUser'), data, { headers });
  }

  findLocation(value) {
    const token = localStorage.getItem('currentUser');
    const headers = new HttpHeaders({
      'authorization': token
    });
    const data = {
      'value': value
    };
    return this.http.post(this.configService.serverIp.concat('/findLocation'), data, { headers });
  }


}
